module.exports = __webpack_public_path__ + "static/media/daw-logo.34cc6072.png";